import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/novel";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-book-open-line text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-50">
                  书香阁
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                让每一位读者都能找到属于自己的精神世界。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/wuxia" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    小说分类
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categoryList.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2">
                <li className="text-sm text-foreground-300">
                  <i className="ri-mail-line mr-1"></i> contact@shuxiangge.com
                </li>
                <li className="text-sm text-foreground-300">
                  <i className="ri-phone-line mr-1"></i> 400-888-6688
                </li>
                <li className="text-sm text-foreground-300">
                  <i className="ri-map-pin-line mr-1"></i> 北京市朝阳区
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 书香阁 版权所有 | 京ICP备2024000000号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}